// Whether the boat's anchor watch is on, for the bar's mode slot (TOM-358,
// ADR 0306 §3: At anchor takes the slot while a watch is on, whatever the
// mode says). Read on load, when the page becomes visible, and every minute
// while it is; a failed read keeps the last answer.

import { useEffect, useState } from 'react';
import { parseAnchorWatchStatus } from '@neomaris/protocol';

import { api } from '../api';

const ANCHOR_WATCH_READ_MS = 60_000;

export function useAnchorWatchOn(boatId: string): boolean {
  const [on, setOn] = useState(false);
  useEffect(() => {
    setOn(false);
    if (boatId === '') return;
    let alive = true;
    const read = async () => {
      if (document.hidden) return;
      try {
        const status = parseAnchorWatchStatus(await api(`/v1/boats/${boatId}/anchor-watch`));
        if (alive && status !== null) setOn(status.enabled);
      } catch {
        // Keep the last answer.
      }
    };
    void read();
    const id = window.setInterval(() => void read(), ANCHOR_WATCH_READ_MS);
    const onVisible = () => void read();
    document.addEventListener('visibilitychange', onVisible);
    return () => {
      alive = false;
      window.clearInterval(id);
      document.removeEventListener('visibilitychange', onVisible);
    };
  }, [boatId]);
  return on;
}
